var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{},[_c('div',{staticClass:"corpoConteudo conteudo",attrs:{"x-ms-format-detection":"none"},on:{"!click":function($event){return _vm.$store.commit('setHoraEvento')},"!keyup":function($event){return _vm.$store.commit('setHoraEvento')}}},[_c('v-content',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }